const cloneObject = (obj) => {
	if (obj === null || typeof obj !== 'object') {
		return obj;
	}

	if (obj instanceof Function) {
		return obj;
	}

	if (obj instanceof Date) {
		return new Date(obj);
	}

	if (Array.isArray(obj)) {
		return obj.map((item) => cloneObject(item));
	}

	if (typeof obj === 'object') {
		const copiedObj = {};
		Object.keys(obj).forEach((key) => {
			copiedObj[key] = cloneObject(obj[key]);
		});
		return copiedObj;
	}
	return undefined;
};

export default cloneObject;
